/**
 * Les initiales d'un nom, pour une pastille.
 *
 * Deux copies identiques vivaient dans le fil d'activité CRM et dans
 * l'avatar de la liste de contacts, et j'en ai créé la seconde moi-même le
 * 2026-09-30 en découpant un écran. Une seule ici.
 */
export function getInitials(name?: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const premier = parts[0] ?? '';
  const dernier = parts[parts.length - 1] ?? '';
  if (parts.length === 1) return (premier[0] || '?').toUpperCase();
  return ((premier[0] || '') + (dernier[0] || '')).toUpperCase();
}
